module.exports = __webpack_public_path__ + "img/nutrieon-protein-advance-87x87-2.2e85eece.png";